module.exports = __webpack_public_path__ + "img/mindscapcourse.7655b5d1.svg";